import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import useAuth from "../../Hooks/useAuth";

export default function GuestGuard({
  children,
}: {
  children: React.ReactNode;
}) {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isLoggedIn) {
      navigate(
        location?.state?.from
          ? location?.state?.from
          : process.env.REACT_APP_DEFAULT_PATH,
        {
          state: { from: "" },
          replace: true,
        }
      );
    }
  }, [isLoggedIn, navigate, location]);

  return <>{children}</> || null;
}
